import styled from '@emotion/styled';

export const HeaderAndContentWrapper = styled.div`
  position: relative;
`;

export const ContentWrapper = styled.div`
  min-height: calc(100vh - 480px);
`;

export const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 480px);
  margin: 0;
`;
